import { render, staticRenderFns } from "./ItemsInventory.vue?vue&type=template&id=64efe194&"
import script from "./ItemsInventory.vue?vue&type=script&lang=js&"
export * from "./ItemsInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports